
export const tableConfig = {
  minItemsPerPage: 10,
  maxItemsPerPage: 20,
};
